import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { TableEventType } from '../models/enums/action-type.enum';
import { TableConfiguration } from '../models/table-config.model';
import { TableEvent } from '../models/table-event.model';

@Injectable()
export class TableConfigurationService {

  tableConfig: TableConfiguration;

  public initialization(tableConfig: TableConfiguration) {
    this.tableConfig = tableConfig;
  }

  public sendEvent(eventType: TableEventType, payload: Record<string, unknown> = {}) {
    const events = this.tableConfig.events;
    events.next(TableEvent.create({eventType, payload}));
  }

  public getEventObservable(eventType: TableEventType) {
    const events = this.tableConfig.events;
    return events.asObservable().pipe(
      filter(event => event.eventType === eventType),
    );
  }

  public getDisplayedColumns(tableConfig: TableConfiguration) {
    const displayedColumns = tableConfig.columns.map(column => column.columnName);
    return displayedColumns;
  }
}
